import * as HttpService from "./http.service";
import {
    ADD_INITIATIVE_EMPLOYEE,
    CREATE_FIRM_INITIATIVE,
    DOWNLOAD_FIRM_INITIATIVE_TEMPLATE,
    GET_ALL_FIRM_INITIATIVES,
    GET_FIRM_INITIATIVE_BY_ID,
    GET_FIRM_INITIATIVE_CSV,
    PROCESS_FIRM_INITIATIVE_LOAD,
    UPDATE_FIRM_INITIATIVE,
    UPDATE_FIRM_INITIATIVE_STATUS,
    UPDATE_INITIATIVE_EMPLOYEE
} from "./url.service"

export const createFirmInitiative = ({ data }) => {
    return HttpService.postWithAuth(CREATE_FIRM_INITIATIVE, data);
}

export const getAllFirmInitiatives = ({ offset = 10, limit = 0, search, filters, sorts, isEmployee = '' }) => {
    return HttpService.getWithAuth(GET_ALL_FIRM_INITIATIVES({ offset, limit, search, filters, sorts, isEmployee }))
}

export const getFirmInitiativesExport = ({ search, filters, sorts }) => {
    return HttpService.getWithAuth(GET_FIRM_INITIATIVE_CSV({ search, filters, sorts }))
}

export const getFirmInitiativeById = ({ id }) => {
    return HttpService.getWithAuth(GET_FIRM_INITIATIVE_BY_ID({ id }))
}

export const updateFirmInitiative = ({ id, detail }) => {
    return HttpService.putWithAuth(UPDATE_FIRM_INITIATIVE({ id }), detail)
}

export const updateFirmInitiativeStatus = ({id, detail}) => {
    return HttpService.putWithAuth(UPDATE_FIRM_INITIATIVE_STATUS(id), detail)
}

export const addInitiativeEmployee = ({ data }) => {
    return HttpService.postWithAuth(ADD_INITIATIVE_EMPLOYEE, data);
}

export const updateInitiativeEmployee = ({ id, detail }) => {
    return HttpService.putWithAuth(UPDATE_INITIATIVE_EMPLOYEE({ id }), detail)
}

export const downloadBulkUploadTemplate = () => HttpService.getWithAuth(DOWNLOAD_FIRM_INITIATIVE_TEMPLATE)

export const processFirmInitiatives = ({ data }) => HttpService.postWithAuth(PROCESS_FIRM_INITIATIVE_LOAD, data)
